import RecordVideoComponent from './record-video.component'

export default RecordVideoComponent
